module.exports = __webpack_public_path__ + "media/images/DataServices-283a00fc334fda51ff0cbfb2704c5125.svg";